/**
 * Trạng thái phê duyệt nội dung danh mục
 */
export default {
    Add: 1,
    Merge: 2,
}